import { createSlice } from '@reduxjs/toolkit'

const initialState = {}

const designazioneSlice = createSlice({
  name: 'designazione',
  initialState,
  reducers: {
    resetDesignazione() {
      return initialState
    },
    setDesignazione(state, action) {
      state.designazione = action.payload
    },
    setSelectedGara(state, action) {
      state.selectedGara = action.payload
    },
    setSelectedArbitro1(state, action) {
      state.selectedArbitro1 = action.payload
    },
    setSelectedArbitro2(state, action) {
      state.selectedArbitro2 = action.payload
    },
    setCheckAccept(state, action) {
      state.checkAccept = action.payload
    },
    setCheckReject(state, action) {
      state.checkReject = action.payload
    },
  },
})

export const {
  resetDesignazione,
  setDesignazione,
  setSelectedGara,
  setSelectedArbitro1,
  setSelectedArbitro2,
  setCheckAccept,
  setCheckReject,
} = designazioneSlice.actions

export default designazioneSlice.reducer
